//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('visitorConfirm', {
//        templateUrl: 'views/components/views/visitorConfirm/visitorConfirm.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'visitorConfirmService', function ($stateParams, stateService, visitorConfirmService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let inOut = $stateParams.inout;
//            let persNo = $stateParams.pers_no;

//            vm.model = {
//                inOut: inOut,
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadEdit() {
//                vm.model.edit = (await visitorConfirmService.getEdit({
//                    inout: inOut,
//                    pers_no: persNo
//                }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                let mergeObj = {};
//                mergeObj = vm.model.edit;
//                mergeObj.inout = inOut;

//                visitorConfirmService.saveObj(mergeObj).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
